//#region Date Generators

import { UnixTimestamp } from "./timestamps.tools";
import { toTimestamp, valueOf } from "./timestamps.tools.definitions";
import { beginOf, getNowDate, getTodayDate } from "./timestamps.tools.tsdate";

//* there is also a fromDateObject function in timestamps.tools.tsdate.ts that allow you to build a TsDate

/**
 * Get today date in UnixTimestamp format
 * @returns {UnixTimestamp}
 */
export function TODAY(): UnixTimestamp {
    const todayDate = getTodayDate();
    return todayDate.uts;
}

/**
 * Get current week date in UnixTimestamp format
 * @returns {UnixTimestamp}
 */
export function WEEK_START(): UnixTimestamp {
    const todayDate = getTodayDate();
    return beginOf(todayDate, "week").uts;
}

/**
 * Get current instant in UnixTimestamp format
 * @returns {UnixTimestamp}
 */
export function NOW(): UnixTimestamp {
    const now = getNowDate();
    return now.uts;
}

/**
 * Get current instant in UnixTimestamp format (REAL => not modified by TimestampsSettings.overrideTodayDate)
 * REAL_NOW should almost never be used since we want to be able to override the current date in the whole application, it is usually used only in logs
 */
export function REAL_NOW(): UnixTimestamp {
    return toTimestamp(Math.round(Date.now() / 1000));
}

/** Get random dateTs between two timestamps included */
export function getRandomTs(start: UnixTimestamp, end: UnixTimestamp): UnixTimestamp {
    const r = Math.random();
    return toTimestamp(valueOf(start) + Math.round((valueOf(end) - valueOf(start)) * r));
}

//#endregion